import { defineStore, mapActions } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'
import _ from 'lodash'

export const useAccessControlStore = defineStore('accessControlStore', {
	state: () => ({
		corporateDetail: {},
		roleList: [],
		localUserList: [],
		userList: [],
		userActiveList: [],
		userHubManagerList: [],
		userBankerList: [],
		userSsaList: [],
		userSseList: [],
		userSeList: [],
		userUplineList: [],
		userLoanOfficerList: [],
		userSelfSubscriptionList: [],
		hubManagerUserList: [],
		teamManagerUserList: [],
		userListByAppCode: [],
    corporateList:[],
	}),
	getters: {
		userAdvisorList(){
			if(_gHlp.isEmpty(this.userList)){
				return 
			}
			return this.userList.filter(item => {
					const statusActive = item.status == 1 ? true : false;
					// Check if any of the item's addresses match the filter criteria
					const hasRole = item.roles && item.roles.some(role => {
						let intersect = _.intersection(role.role_access,['role_mobile_sales_advisor','role_sales_advisor_manager','role_sales_support_manager','role_sales_manager','role_ssa']);
						return (role.application_code == _gAuth.appCode()) && (intersect.length > 0);
					}) ? true : false;
				
					// Return true if both conditions are met, otherwise false
					return statusActive && hasRole;
			});
		}
	},
	actions: {
		//PROMISE METHOD
		fetchUsers(params){
			return new Promise((resolve, reject) => {
				this.localUserList = _gHlp.getLocalStorage('srvAccsCtrl.users');
				let stringParams = _gHlp.generateQueryParams(params);
				axios.get(services.access_control + 'user?' + stringParams, { headers: getHeader() }).then( resp => {
					let results = [];
					if(!_gHlp.isEmpty(resp.data) && !_gHlp.isEmpty(resp.data.data)){
						results = resp.data.data;
						this.localUserList =_gHlp.patchData(this.localUserList,results,'id');
						_gHlp.setLocalStorage('srvAccsCtrl.users',this.localUserList);
					}
					resolve(results);
				}).catch(err=>{
					reject(err);
				})
			})
		},

		//ASYNC METHOD
		async createUserByRefferal(data, public_code, token) {
			try {
				const headers = {
					'Accept': 'application/json',
					'Application-Code': _gAuth.appCode(),
					'Public-Code':public_code,
					'G-Captcha':token
				}	
				const res = await axios.post(services.access_control + 'referral-registration',data,{ headers: headers })
				return res.data.data
			} catch (e) {
				return null
			}
		},
		async getUserHubManagerList() {
			try {
				const res = await axios.get(services.access_control + 'user_sas_hub_manager_list', { headers: getHeader() })
				this.userHubManagerList = res.data.data
			} catch (e) {
				this.userHubManagerList = []
				// console.log('Get user hub manager list failed:' + e.response.data.message)
			}
		},
		async getHubManagerUserList() {
			try {
				const res = await axios.get(services.access_control + 'user_hub_manager_list', { headers: getHeader() })
				this.hubManagerUserList = res.data.data
			} catch (e) {
				this.hubManagerUserList = []
				// console.log('Get user hub manager list failed:' + e.response.data.message)
			}
		},
		async getTeamManagerUserList() {
			try {
				const res = await axios.get(services.access_control + 'user_team_manager_list', { headers: getHeader() })
				this.teamManagerUserList = res.data.data
			} catch (e) {
				this.teamManagerUserList = []
				// console.log('Get user hub manager list failed:' + e.response.data.message)
			}
		},
		async getUserSsaList() {
			try {
				const res = await axios.get(services.access_control + 'user_sas_ssa_list', { headers: getHeader() })
				this.userSsaList = res.data.data
			} catch (e) {
				this.userSsaList = []
				// console.log('Get user SSA list failed:' + e.response.data.message)
			}
		},
		async getUserSseList() {
			try {
				const res = await axios.get(services.access_control + 'user_sas_sse_list', { headers: getHeader() })
				this.userSseList = res.data.data
			} catch (e) {
				this.userSseList = []
				// console.log('Get user SSE list failed:' + e.response.data.message)
			}
		},
		async getUserSeList() {
			try {
				const res = await axios.get(services.access_control + 'user_sas_se_list', { headers: getHeader() })
				this.userSeList = res.data.data
			} catch (e) {
				this.userSeList = []
				// console.log('Get user SE list failed:' + e.response.data.message)
			}
		},
		async getUserBankerList() {
			try {
				const res = await axios.get(services.access_control + 'user_banker_list', { headers: getHeader() })
				this.userBankerList = res.data.data
				
			} catch (e) {
				this.userSeList = []
				console.log(e);
				// console.log('Get user Banker list failed:' + e.response.data.message)
			}
		},
		async getUserLoanOfficer() {
			try {
				const res = await axios.get(services.access_control + 'user_loan_officer_list', { headers: getHeader() })
				this.userLoanOfficerList = res.data.data
			} catch (e) {
				this.userLoanOfficerList = []
				// console.log('Get user Loan Officer list failed:' + e.response.data.message)
			}
		},
		async getUplineList(app_code, corporate_id, user_id = null) {
			let urlSearchParams = new URLSearchParams()
			urlSearchParams.append('application_code', app_code)
			urlSearchParams.append('corporate_id', corporate_id)
			if (user_id) {
				urlSearchParams.append('user_id', user_id)
			}
			try {
				const res = await axios.get(services.access_control + 'user_available_upline_list?' + urlSearchParams.toString(), { headers: getHeader() })
				this.userUplineList = res.data.data
			} catch (e) {
				this.userUplineList = []
				// console.log('Get user upline list failed:' + e.response.data.message)
			}
		},
		async getRoleList() {
			try {
				const res = await axios.get(services.access_control + 'role', { headers: getHeader() })
				this.roleList = res.data.data;
				return this.roleList;
			} catch (e) {
				this.roleList = []
				return this.roleList;
				console.log('Get role list failed:' + e.response.data.message)
			}
		},
		async getUserUseSelfSubscription(corporate_id = null) {
			let urlSearchParams = new URLSearchParams()
			urlSearchParams.append('is_use_corp_subscription', 0);
			urlSearchParams.append('corporate_id', corporate_id);
			try {
				const res = await axios.get(services.access_control + 'user?' + urlSearchParams.toString(), { headers: getHeader() })
				this.userSelfSubscriptionList = res.data.data
			} catch (e) {
				this.userSelfSubscriptionList = []
				// console.log('Get user SE list failed:' + e.response.data.message)
			}
		},
		async getUsers(corporate_id = null, app_code = null) {
			let params = {}
			if(!_gHlp.isEmpty(corporate_id)){
				params['corporate_id'] = corporate_id
			}
			if(!_gHlp.isEmpty(app_code)){
				params['application_code'] = app_code
			}
			try {
				const res = await this.fetchUsers(params);
				this.userList = res
			} catch (e) {
				this.userList = []
				// console.log('Get user SE list failed:' + e.response.data.message)
			}
		},
		async getUser(id,is_refresh=false){
			this.localUserList = _gHlp.getLocalStorage('srvAccsCtrl.users');
			let user = null;
			if(!_gHlp.isEmpty(this.localUserList) && !is_refresh){
				user = this.localUserList.find((o)=>{ return o.id == id});
			}
			if(!_gHlp.isEmpty(user)){
				return user;
			}
			try {
				const res = await axios.get(services.access_control + 'user/' + id, { headers: getHeader() })
				if(!_gHlp.isEmpty(res.data) && !_gHlp.isEmpty(res.data.data)){
					user = res.data.data;
					this.localUserList =_gHlp.patchData(this.localUserList,[user],'id');
					_gHlp.setLocalStorage('srvAccsCtrl.users',this.localUserList);
				}
				return user
			} catch (e) {
				return null;
			}
		},
		async getActiveCorporate(corporate_id = null) {
			try {
				const res = await axios.get(services.access_control + 'corporate/' + corporate_id, { headers: getHeader() })
				this.corporateDetail = res.data.data
			} catch (e) {
				this.corporateDetail = {}
				// console.log('Get corporate detail failed:' + e.response.data.message)
			}
		},
    async getCorporates() {
      try {
				const res = await axios.get(services.access_control + 'corporate', { headers: getHeader() })
        this.corporateList = res.data.data
      } catch (e) {
        this.corporateList = []
        console.log('Get corporates failed:' + e.response.data.message)
      }
    },
    async updateCorporates(id,params) {
      try {
				const res = await axios.put(services.access_control + 'corporate/'+id, params, { headers: getHeader() })
        return _gHlp.getValue(res,'data.data',[])
      } catch (e) {
        _gNotif.errorFunction(e)
				return []
      }
    },
    async updateUser(id,data){
      axios.put(services.access_control + 'user/' + id, data, { headers: getHeader() })
      .then(res => {
        _gNotif.notifySuccess('<b>User:</b> - Successfully Updated.');
        this.$emit('closeBellNotificationModal', false)
      })
      .catch(e => {
        _gNotif.errorFunction(e);
      });
    },
    //Solicitor Sales Purchase
    async getSolSalesPurchase() {
     try {
       const res = await axios.get(services.access_control + 'solicitor-sales-purchase', { headers: getHeader() })
       this.salesPurchaseList = res.data.data
     } catch (e) {
       this.salesPurchaseList = []
       console.log('Get Sales Purchase failed:' + e.response.data.message)
     }
   },
   //Solicitor Loan Agreement
   async getSolLoanAgreement() {
     try {
       const res = await axios.get(services.access_control + 'solicitor-loan-agreement', { headers: getHeader() })
       this.loanAgreementList = res.data.data
     } catch (e) {
       this.salesPurchaseList = []
       console.log('Get Loan Agreement failed:' + e.response.data.message)
     }
   },
   //Solicitor User Referral Fees
   async getUserReferralFees() {
     try {
       const res = await axios.get(services.access_control + 'sol-referral-fees', { headers: getHeader() })
       this.userReferraltList = res.data.data
     } catch (e) {
       this.salesPurchaseList = []
       console.log('Get User Referral Fees failed:' + e.response.data.message)
     }
   },
   //Solicitor Status Referral Fees
   async getStatusReferralFees() {
     try {
       const res = await axios.get(services.access_control + 'sol-referral-terms', { headers: getHeader() })
       this.userReferraltList = res.data.data
     } catch (e) {
       this.salesPurchaseList = []
       console.log('Get Status Referral Fees failed:' + e.response.data.message)
     }
   },
   async getUser(id, is_refresh = false) {
		// Cancel previous request if still pending
		if (this.userRequestController) {
			this.userRequestController.abort()
		}
		
		this.userRequestController = new AbortController()
		
		try {
			const res = await axios.get(services.access_control + 'user/' + id, { 
				headers: getHeader(),
				signal: this.userRequestController.signal,
				timeout: 5000 // 5 second timeout
			})
			return res.data.data
		} catch (e) {
			if (e.name === 'AbortError') {
				console.log('User request cancelled')
				return null
			}
			throw e
		}
	}
 }
})

